export const getDayPlannerData = (axiosInstance, eventId, primaryView, day, facilityId) => {
    const params = { primaryView };
    if (day) {
        params.day = day;
    }
    if (facilityId) {
        params.facilityId = facilityId;
    }

    return axiosInstance.get(`v2/tms/events/${eventId}/day-planner`, {
        params,
    });
};

export const getDayPlannerDayConfig = (axiosInstance, eventId, day, previousDay) => {
    return axiosInstance.get(`v2/tms/events/${eventId}/day-planner/day-config`, {
        params: {
            day,
            previousDay,
        },
    });
};

export const saveDayPlannerDayConfig = (axiosInstance, eventId, dayConfigData) => {
    return axiosInstance.post(`v2/tms/events/${eventId}/day-planner/day-config`, dayConfigData);
};

export const getDivisionsAndVirtualDraws = (axiosInstance, eventId, primaryView, dayConfigId, facilityId) => {
    return axiosInstance.get(`v2/tms/events/${eventId}/day-planner/virtual-draws/${dayConfigId}`, {
        params: {
            primaryView,
            facilityId,
        },
    });
};

export const getScoringFormats = (axiosInstance, eventId) => {
    return axiosInstance.get(`v2/tms/events/${eventId}/day-planner/score-formats`);
};

export const getPlanSummary = (axiosInstance, eventId, primaryView, dayConfigId, facilityId) => {
    return axiosInstance.get(`v2/tms/events/${eventId}/day-planner/summary/${dayConfigId}?primaryView=${primaryView}`, {
        params: {
            facilityId,
        },
    });
};

export const updatePlanSummary = (axiosInstance, eventId, primaryView, dayConfigId, facilityId, params) => {
    return axiosInstance.post(`v2/tms/events/${eventId}/day-planner/summary/${dayConfigId}?primaryView=${primaryView}&facilityId=${facilityId}`, params);
};

export const createUpdateDivisionVirtualDraws = (axiosInstance, eventId, dayConfigId, facilityId, params) => {
    return axiosInstance.post(`v2/tms/events/${eventId}/day-planner/virtual-draws/from-divisions/${dayConfigId}?facilityId=${facilityId}`, params);
};

export const createUpdatePointerVirtualDraws = (axiosInstance, eventId, dayConfigId, facilityId, params) => {
    return axiosInstance.post(`v2/tms/events/${eventId}/day-planner/virtual-draws/from-draws/${dayConfigId}?facilityId=${facilityId}`, params);
};

export const runAutoScheduler = (axiosInstance, eventId, primaryView, dayConfigId, facilityId, drawStartMode) => {
    return axiosInstance.post(`v2/tms/events/${eventId}/day-planner/auto-schedule/${dayConfigId}?primaryView=${primaryView}&facilityId=${facilityId}&drawStartMode=${drawStartMode}`);
};

export const deleteAllVirtualDraws = (axiosInstance, eventId, primaryView, dayConfigId, facilityId) => {
    return axiosInstance.delete(`v2/tms/events/${eventId}/day-planner/virtual-draws/${dayConfigId}?primaryView=${primaryView}&facilityId=${facilityId}`);
};

export const deleteVirtualDraw = (axiosInstance, eventId, virtualDrawId) => {
    return axiosInstance.delete(`v2/tms/events/${eventId}/day-planner/virtual-draw/${virtualDrawId}`);
};

export const copyDay = (axiosInstance, eventId, dayConfigId) => {
    return axiosInstance.post(`v2/tms/events/${eventId}/day-planner/copy/${dayConfigId}`);
};
